import { render } from "./StatusPill.vue?vue&type=template&id=17577788"
import script from "./StatusPill.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusPill.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Atoms/StatusPill.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17577788"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17577788', __exports__)) {
    api.reload('17577788', __exports__)
  }
  
  module.hot.accept("./StatusPill.vue?vue&type=template&id=17577788", () => {
    api.rerender('17577788', render)
  })

}


export default __exports__